// "How is this calculated" copy shown in the info popovers of the Beauty statistics screen. Mirrors
// the metric definitions the back documents (README, "Estadísticas de Beauty (panel)"); keep both in
// sync when a definition changes. Each entry is [title, text].

export const DEFINITIONS = {
  occ: [
    "Ocupación de agenda",
    "Horas con turno ÷ horas de agenda. Las horas de agenda salen del horario de trabajo de cada profesional (con sus cortes), menos los bloqueos. Cuentan los turnos confirmados, reservados y los que no asistieron, porque la profesional quedó tomada. No cuentan los cancelados.",
  ],
  rev: [
    "Ingresos cobrados",
    "Lo cobrado online (seña) más lo cobrado en el mostrador con ZocoPDV, menos devoluciones. Se asigna al día del turno, no al día en que entró el pago.",
  ],
  res: [
    "Turnos",
    "Turnos del período confirmados, reservados o marcados como \"No asistió\". No incluye cancelados ni reservas vencidas sin pagar.",
  ],
  ticket: [
    "Ticket promedio",
    "Lo cobrado en los turnos atendidos ÷ cantidad de turnos atendidos. Un turno puede tener varios servicios.",
  ],
  canc: [
    "Cancelaciones",
    "Turnos cancelados ÷ todos los turnos pedidos para el período, cancelados incluidos.",
  ],
  ns: [
    "No asistió",
    "Turnos marcados como \"No asistió\" ÷ turnos del período. \"Sin cobrar\" es lo que quedó sin pagar de esos turnos, descontando la seña.",
  ],
  free: [
    "Horas libres en agenda",
    "Horas de agenda que nadie reservó. Es lo que todavía podés vender, por ejemplo con promociones en horario valle.",
  ],
  link: [
    "Por el link del profesional",
    "Turnos que la clienta sacó desde el link personal de una profesional ÷ turnos del período. Sirve para ver cuánto mueve cada una su link.",
  ],
  comm: [
    "Comisión",
    "Comisión de cada servicio según la configuración de Comisiones (específica del servicio, de la profesional o la del salón). Solo cuentan los turnos atendidos y, si el salón lo tiene activado, los pagados completos, como en la liquidación del PDV.",
  ],
};
